export type UrlFragmentType = "broker" | "central" | null;
type UrlFragmentPaymentCycle = "monthly" | "annual" | null;

export type UrlFragmentData = Readonly<{
	hash: string;
	type: UrlFragmentType;
	plan: string | null;
	paymentCycle: UrlFragmentPaymentCycle;
}>;


const getType = (fragment: string): UrlFragmentType => {
	switch(fragment.split("__")[0]) {
		case "signupbroker":
			return "broker";
		case "signupcentral":
			return "central";
		default:
			return null;
	}
};

const getPlan = (fragment: string): string | null => {
	const plan = fragment.split("__")[1];
	return plan || null;
};

const getPaymentCycle = (fragment: string): UrlFragmentPaymentCycle => {
	if(fragment.includes("monthly")) {
		return "monthly";
	} else if(fragment.includes("annual")) {
		return "annual";
	}
		return null;

};

export const parseUrlFragment = (input: string): UrlFragmentData | null => {
	const fragment = input.replace("#", "");
	if(!fragment.startsWith("signup")) {
		return null;
	}

	return {
		hash: fragment,
		type: getType(fragment),
		plan: getPlan(fragment),
		paymentCycle: getPaymentCycle(fragment),
	};
};
